<template>
  <path
    d="M4.00004 13.3333L1.33337 10.6666L2.26671 9.73325L3.33337 10.7666V3.33325H4.66671V10.7666L5.73337 9.73325L6.66671 10.6666L4.00004 13.3333ZM8.00004 12.6666V11.3333H14.6667V12.6666H8.00004ZM8.00004 8.66659V7.33325H14.6667V8.66659H8.00004ZM8.00004 4.66659V3.33325H14.6667V4.66659H8.00004Z"
  />
</template>
